exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notifications-list[data-v-423f2a9e]{max-height:350px;overflow-y:auto}.dropdown-item[data-v-423f2a9e]{white-space:normal}", ""]);

// exports
